<li
  class="timeline-item"
  [ngClass]="{
    'current-item': inProgress,
    'item-next': !visited,
    'last-item': isLast
  }"
  *ngIf="!summaryItem?.hide"
>
  <div class="timeline-marker"></div>
  <div class="timeline-content">
    <ng-container *ngIf="inProgress">
      <p class="flex items-center timeline-title">
        {{ summaryItem?.templateOptions?.cachedLabel }}
      </p>
      <p class="timeline-current-progress">You are right here</p>
    </ng-container>
    <ng-container *ngIf="!inProgress">
      <p class="flex items-center" style="cursor: pointer" (click)="valid && !inProgress && handlePageChange()">
        {{ summaryItem?.templateOptions?.cachedLabel }}
      </p>
      <p class="summary-link" (click)="resumeProgressClick()" *ngIf="showProgressIndicator">Pick Up Where You Left Off</p>
    </ng-container>
  </div>
  <div class="summary-actions">
    <img src="/assets/icon/pencil.svg" *ngIf="visited" (click)="handlePageChange()" />
    <img src="/assets/icon/delete.svg" *ngIf="hasRepeats" (click)="removeItemClick()" />
  </div>
</li>
